import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetPriceByIdData } from "../../../lib/data";
import i18n from "../../../lib/i18n";
import EditPricesUi from "../../../ui/prices/editPricesUi";

export default function EditPrices() {

    const { priceId } = useParams();
    const [pricesData, setPricesData] = useState({});
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const priceData = await GetPriceByIdData(priceId);
        setPricesData(priceData.data);
    };

    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("nav.edit_delivery_price")}</h1>
                <EditPricesUi data={pricesData} />
            </div>
        </div>
    );
};